import { ColorPicker } from "react-color-palette";
import { IconButton, Modal, Portal, TextInput } from "react-native-paper";
import { View } from "react-native";
import { BoxCurrentColor, ContainerPickerColor, TextColorHex } from "./style";
import "react-color-palette/css";

const PickerColorHex = ({
  setShow,
  colorName,
  props,
  isShowPicker,
  setChange,
}) => {
  
  // Função para normalizar e validar a cor
  const normalizeColor = (inputColor) => {
    if (!inputColor) return null;
    
    // Remove todos os espaços em branco
    let normalized = inputColor.trim().replace(/\s/g, '');
    
    // Adiciona # se não existir
    if (!normalized.startsWith('#')) {
      normalized = '#' + normalized;
    }
    
    // Valida se é um hex válido (3 ou 6 caracteres após o #)
    const hexRegex = /^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/;
    if (!hexRegex.test(normalized)) {
      return null; // Retorna null se não for válido
    }
    
    // Converte para uppercase
    return normalized.toUpperCase();
  };

  // Handler para mudança de texto
  const handleTextChange = (text) => {
    // Remove espaços enquanto digita
    const cleanText = text.replace(/\s/g, '');
    
    // Atualiza o estado temporariamente (permite digitação)
    setChange({ ...colorName, hex: cleanText });
  };

  // Handler para quando o usuário termina de editar (blur)
  const handleBlur = () => {
    const normalizedColor = normalizeColor(colorName.hex);
    
    if (normalizedColor) {
      // Se a cor é válida, atualiza com a versão normalizada
      setChange({ ...colorName, hex: normalizedColor });
    } else {
      // Se a cor é inválida, volta para o valor anterior ou usa uma cor padrão
      // Você pode escolher manter o valor anterior ou definir uma cor padrão
      console.warn('Cor inválida:', colorName.hex);
      // Opcional: reverter para cor anterior ou usar cor padrão
      // setChange({ ...colorName, hex: '#000000' });
    }
  };

  return (
    <View>
      <TextColorHex>
        <BoxCurrentColor
          style={{
            backgroundColor: colorName.hex,
          }}
          onClick={setShow}
        />

        <TextInput
          value={colorName.hex}
          onChangeText={handleTextChange}
          onBlur={handleBlur}
          style={{
            backgroundColor: "#fff",
            width: 80,
            height: 24,
            zIndex: 0,
            marginLeft: "0.2rem",
            borderBottomWidth: "1px",
            borderBottomColor: "#B1B1B1",
            textAlignVertical: "top",
          }}
          contentStyle={{ paddingHorizontal: "0px", border: "none" }}
          theme={{
            colors: {
              outline: "#fff",
              primary: "#fff",
            },
          }}
          textColor="#000"
          mode="outlined"
          maxLength={7}
        />
      </TextColorHex>

      {isShowPicker && (
        <Portal>
          <Modal
            visible={isShowPicker}
            onDismiss={setShow}
            animationType="slide"
            contentContainerStyle={{
              alignItems: "center",
              boxShadow: "none",
            }}
          >
            <ContainerPickerColor>
              <IconButton
                icon="close"
                selected
                size={20}
                style={{ margin: 0, alignSelf: "end" }}
                iconColor="white"
                onPress={setShow}
              />
              <ColorPicker hideInput={["rgb", "hsv"]} height={100} {...props} />
            </ContainerPickerColor>
          </Modal>
        </Portal>
      )}
    </View>
  );
};

export default PickerColorHex;